import { Mqtt_Topics_studyChanges, Mqtt_Topics_patientChanges } from "../RAWMap.Models/Api.js";
import { ofArray } from "../fable_modules/fable-library-js.4.19.3/List.js";
import { Msg } from "./PatientTypes.js";

export function subscribe(uid) {
    return [ofArray([Mqtt_Topics_patientChanges(uid), Mqtt_Topics_studyChanges(uid)]), (Item) => (new Msg(17, [Item]))];
}

